module.exports = __webpack_public_path__ + "static/media/ball.svg";


//////////////////
// WEBPACK FOOTER
// ./src/Tekentool/assets/default/ball.svg
// module id = 55
// module chunks = 0